export enum SearchOption {
  SEARCH = 'SEARCH',
  ADD = 'ADD',
  CAMERA = 'CAMERA',

  NONE = 'NONE',
}
